module.exports = __webpack_public_path__ + "static/media/Rukh_Lala_OVERALL_02.a57d9cd7.jpg";